<template>
  <BoxAddressesTable />
</template>

<script lang="ts" setup>
import { useAuthorizationContext } from '@/composables/deepadmin/use-authorization-context.ts'
import usePageAccess from '@/composables/deepadmin/use-page-access.ts'
import BoxAddressesTable from '@/components/deepbox/box/BoxAddressesTable.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepbox.box.addresses',
  },
})

const { permissions } = useAuthorizationContext()

usePageAccess(computed(() => !permissions.canViewBoxes))
</script>
